// export type TransportType = "individual" | "public-transport"

export enum TransportType {
    Individual = 'individual-transport',
    Public = 'public-transport',
    All = 'all'
}
